import { DEFAULT_FILTER_TYPE } from '../constants';
import LocalStorage from '../services/LocalStorage';
import { updateReviewsHelpful } from '../utils/helpful';

export default ({ reviews, total_count, ...rest }) => {
    const helpfulMap = LocalStorage.getHelpfulReviewsList();
    updateReviewsHelpful({ reviews, helpfulMap });

    return {
        reviews,
        total_count,
        filteredTotalCount: total_count,
        type: DEFAULT_FILTER_TYPE,
        helpful: helpfulMap,
        filters: {},
        filtersCountersInitial: rest.filters_counters,
        ...rest,
    };
};
